/* Top Pallets - homepage polish (2026-09-23). Source: shopify-theme/tp-home-polish.js.
   1. FAQ rows slide open/closed instead of snapping (native <details> has no animation).
   2. "Trusted Across Australia" pins drop in once when scrolled to.
   3. The footer truck strip only runs while it is on screen. */
(function () {
  /* ONE accordion handler per page. product.json used to carry its own copy in a custom-liquid block
     (window.__tpSmoothDetails); both opened then shut the same row on one click (FAQs "don't expand",
     Elvin 23/09). That copy is gone (patch-site-polish.py); the flag stops any other one attaching. */
  if (window.__tpHomePolish) return;
  window.__tpHomePolish = window.__tpSmoothDetails = true;
  document.documentElement.classList.add('tp-js');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var EASE = 'cubic-bezier(.2,.7,.2,1)';

  function initFaq(details) {
    if (details.dataset.tpAnim) return;
    details.dataset.tpAnim = '1';
    var summary = details.querySelector('summary');
    var body = details.querySelector('.accordion__content');
    if (!summary || !body) return;
    var anim = null;

    function finish(open) {
      details.open = open;
      details.classList.remove('tp-opening', 'tp-closing');
      details.style.height = details.style.overflow = '';
      anim = null;
    }

    summary.addEventListener('click', function (e) {
      if (reduce || !details.animate || document.hidden) return;
      e.preventDefault();
      var from = details.offsetHeight;
      var closing = details.classList.contains('tp-opening') || (details.open && !details.classList.contains('tp-closing'));
      if (anim) anim.cancel();
      details.style.overflow = 'hidden';
      var to;
      if (closing) {
        details.classList.remove('tp-opening');
        details.classList.add('tp-closing');
        to = summary.offsetHeight;
      } else {
        details.classList.remove('tp-closing');
        details.classList.add('tp-opening');
        details.style.height = from + 'px';
        details.open = true;
        to = summary.offsetHeight + body.offsetHeight +
             parseFloat(getComputedStyle(body).marginTop) + parseFloat(getComputedStyle(body).marginBottom);
        var fade = body.animate([{ opacity: 0, transform: 'translateY(-6px)' }, { opacity: 1, transform: 'none' }],
                                { duration: 320, easing: EASE, delay: 60, fill: 'backwards' });
        setTimeout(function () { fade.cancel(); }, 460);
      }
      var ms = Math.min(420, Math.max(220, Math.abs(to - from) * 1.2));
      var mine = details.animate([{ height: from + 'px' }, { height: to + 'px' }], { duration: ms, easing: EASE });
      anim = mine;
      details.style.height = '';  // the animation drives the height; never leave a fixed one behind
      var done = function () { if (anim === mine) { mine.cancel(); finish(!closing); } };
      mine.onfinish = done;
      setTimeout(done, ms + 80);  // finish events are held back in background tabs
    });
  }

  function init() {
    // homepage FAQ + the product page dropdowns (Product Information etc.) - same Dawn <details> markup
    document.querySelectorAll('.collapsible-content .accordion details, .product__accordion details').forEach(initFaq);

    var targets = document.querySelectorAll('.locations, .tp-truck-strip');
    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (t) { t.classList.add('tp-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var el = en.target;
        if (el.classList.contains('tp-truck-strip')) {
          el.classList.toggle('tp-paused', !en.isIntersecting);
        } else if (en.isIntersecting) {
          el.classList.add('tp-in');
          io.unobserve(el);
        }
      });
    }, { threshold: 0.25 });
    targets.forEach(function (t) {
      if (t.classList.contains('tp-truck-strip')) t.classList.add('tp-paused');
      io.observe(t);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
